import format from "date-fns/format";

const DATE_TIME_FORMAT = "D MMM YYYY - h:mm aa";
const TIME_FORMAT = "h:mm aa";

export const formatDateTime = (
  seconds: number,
  dateTimeFormat = DATE_TIME_FORMAT
) => {
  if (!seconds || isNaN(seconds)) {
    return "";
  }
  return format(new Date(seconds * 1000), dateTimeFormat);
};

export const formatTime = (seconds: number, dateTimeFormat = TIME_FORMAT) => {
  return formatDateTime(seconds, dateTimeFormat);
};

export const isoToday = () => new Date().toLocaleString("sv-SE").slice(0, 10);
export const vuetifyMinutesAllowedBuilder = (interval = 15) => (m: number) =>
  m % interval === 0;
export const vuetifyQuarterAllowed = vuetifyMinutesAllowedBuilder();
